import * as Yup from "yup";

export const changeProfilePasswordSchema = Yup.object({
  current_password: Yup.string().min(6).required("Please enter current password"),
  new_password: Yup.string().min(6).required("Please enter new password"),
  confirmPassword: Yup.string()
    .required()
    .oneOf([Yup.ref("new_password"), null], "Confirm new password must match"),
});
